import * as React from 'react';
import { ChildProps } from 'react-apollo';
import * as I18n from 'i18n-js';
import FormGroupWithInput from '@reverbdotcom/commons/dist/components/form_group_with_input';
import FormGroupWithSelect from '@reverbdotcom/commons/dist/components/form_group_with_select';
import { withUserContext, IUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import bind from '@reverbdotcom/commons/dist/bind';
import TokenizedCreditCardHiddenFields from './tokenized_credit_card_hidden_fields';
import {
  ITokenizedCreditCardData,
  ICardData,
  IBillingCardAddress,
  buildCardData,
  buildTokenizedCreditCardData,
  buildBillingCardAddress,
} from './card_data';
import withCountriesApollo from '../components/addresses/with_countries_apollo';
import {
  core_apimessages_Country as ICountry,
  Countries,
} from '../schemas/rql';

type IProps = ChildProps<IUserContext, Countries.Query>;

interface IState {
  cardData: ICardData;
  tokenizedFields: ITokenizedCreditCardData;
  billingAddress: IBillingCardAddress;
}

class BillingCreditCardHtmlFormWithoutApolloCountries extends React.Component<IProps, IState> {
  constructor(props) {
    super(props);

    this.state = {
      cardData: {
        ...buildCardData(),
        cardholderName: props.user.name,
      },
      billingAddress: {
        ...buildBillingCardAddress(),
        countryCode: 'US',
      },
      tokenizedFields: buildTokenizedCreditCardData(),
    };
  }

  @bind
  onFieldUpdate(newTokenizedFields: Partial<ITokenizedCreditCardData>) {
    const tokenizedFields: ITokenizedCreditCardData = { ...this.state.tokenizedFields, ...newTokenizedFields };
    this.setState({ tokenizedFields });
  }

  @bind
  onCardDataUpdate(newCardData: Partial<ICardData>) {
    const cardData: ICardData = { ...this.state.cardData, ...newCardData };
    this.setState({ cardData });
  }

  @bind
  onBillingAddressUpdate(newAddressData: Partial<IBillingCardAddress>) {
    const billingAddress: IBillingCardAddress = { ...this.state.billingAddress, ...newAddressData };
    this.setState({ billingAddress });
  }

  countries(): ICountry[] {
    return this.props.data.countries.countries;
  }

  getCountryOptions() {
    return this.countries().map((country) => {
      return {
        value: country.countryCode,
        text: country.name,
      };
    });
  }

  renderPlaceholder() {
    return (
      <p className="formatted-address formatted-address--placeholder">
        <span className="formatted-address__highlight" />
      </p>
    );
  }

  render() {
    if (this.props.data.loading) { return this.renderPlaceholder(); }
    return (
      <div className="scaling-padding-2 bg-offwhite bg--lighten bd-1 bd--offwhite bd-rounded scaling-mb-2">
        <FormGroupWithInput
          inputName="credit_card[cardholder_name]"
          label={I18n.t('discovery.creditCardForm.nameOnCard')}
          value={this.state.cardData.cardholderName}
          updateField={this.onCardDataUpdate}
          fieldName="cardholderName"
          required
        />
        <TokenizedCreditCardHiddenFields
          onTokenizedFieldUpdate={this.onFieldUpdate}
          onCardDataUpdate={this.onCardDataUpdate}
          tokenizedFields={this.state.tokenizedFields}
          cardData={this.state.cardData}
        />
        <div className="g-container">
          <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
            <FormGroupWithInput
              label={I18n.t('discovery.creditCardForm.postalCode')}
              fieldName="postalCode"
              inputName="billing_address[postal_code]"
              value={this.state.billingAddress.postalCode}
              updateField={this.onBillingAddressUpdate}
              required
            />
          </div>
          <div className="g-col-6 g-col-mobile-12 scaling-mb-2">
            <FormGroupWithSelect
              label={I18n.t('discovery.creditCardForm.country')}
              fieldName="countryCode"
              inputName="billing_address[country_code]"
              updateField={this.onBillingAddressUpdate}
              value={this.state.billingAddress.countryCode}
              required
              options={this.getCountryOptions()}
            />
          </div>
        </div>
        <div className="icon-l-lock size-90">
          {I18n.t('discovery.creditCardForm.storedSecurely')}
        </div>
      </div>
    );
  }
}

const BillingCreditCardHtmlForm = withCountriesApollo(withUserContext(BillingCreditCardHtmlFormWithoutApolloCountries));

export { BillingCreditCardHtmlForm, BillingCreditCardHtmlFormWithoutApolloCountries };
export default BillingCreditCardHtmlForm;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/credit_cards/billing_credit_card_html_form.tsx